<style lang="stylus">
    .usertag-modal-container
        border none
        overflow hidden
        .dialog-slot
            padding 0 !important
        iframe
            display block
            outline: 1px solid #0000000D
            outline-offset -1px
            box-shadow: 0px 15px 30px 0px #00000026
            border-radius 8px
            box-sizing content-box
</style>

<template>
    <Dialog
        ref="dialogDom"
        class="usertag-modal-container"
        :style="{ width: `${winWidth}px`, height: `${winHeight}px` }"
        :isShow="true"
        :mask="true"
        :hiddenTitle="true"
        @close="closeDialog"
    >
        <iframe ref="userTagModal" :style="{ width: `${winWidth}px`, height: `${winHeight}px` }" :src="url" frameborder="0"></iframe>
    </Dialog>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    @Component({
        components: {
            Dialog,
        },
    })
    export default class UserTagModal extends Vue {
        winWidth = 0;
        winHeight = 0;
        get url() {
            let url = "";
            const host = "https://www.edrawmax.cn/public/usertag/";
            const hostEn = "https://www.edrawmax.com/public/usertag/";
            const hostCntest = "https://wmp.edrawsoft.cn/cn/usertag/";
            const hostEntest = "https://wmp.edrawsoft.cn/en/usertag/";
            if (this.isTestEnv) {
                url = this.internal ? hostCntest : hostEntest;
            } else {
                url = this.internal ? host : hostEn;
            }
            return url + `?platform=web&lang=${this.lang}`;
        }
        closeDialog() {
            this.$bus.$emit("closeUserTag");
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        get userInfo() {
            return this.$store.getters.apiParam;
        }
        userTagMessageHandle(e) {
            const key = e.data.key ? e.data.key.split("_") : [],
                params = e.data.params;
            let prefix = key[0] || "";
            if (prefix == "userTag") {
                const str = key[1];
                if (str == "webUserInfo") {
                    this.postMessageToFrame({
                        key: "userInfo",
                        params: JSON.stringify({
                            user_id: this.userInfo.id,
                            token: this.userInfo.token,
                        }),
                    });
                } else if (str == "setWinSize") {
                    this.winWidth = params[0].w;
                    this.winHeight = params[0].h;
                    this.$nextTick(() => {
                        (this.$refs.dialogDom as any).resetPosition();
                    });
                } else if (str == "refreshRecommend") {
                    this.$bus.$emit("refreshRecommend");
                    this.closeDialog();
                } else if (str == "track") {
                    this.sensors.track(params[0].event, params[0].data);
                } else if (str == "closeWin") {
                    this.closeDialog();
                }
            }
        }
        postMessageToFrame(msg) {
            (this.$refs.userTagModal as HTMLIFrameElement).contentWindow.postMessage(msg, "*");
        }
        resetPos() {
            (this.$refs.dialogDom as any).resetPosition();
        }
        mounted() {
            window.addEventListener("message", this.userTagMessageHandle);
            window.addEventListener("resize", this.resetPos);
        }
        beforeDestroy() {
            window.removeEventListener("message", this.userTagMessageHandle);
            window.removeEventListener("resize", this.resetPos);
        }
    }
</script>
